import { render, staticRenderFns } from "./commodityModal.vue?vue&type=template&id=d355d280&scoped=true&"
import script from "./commodityModal.vue?vue&type=script&lang=js&"
export * from "./commodityModal.vue?vue&type=script&lang=js&"
import style0 from "./commodityModal.vue?vue&type=style&index=0&id=d355d280&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d355d280",
  null
  
)

export default component.exports